import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Baseservice } from './baseservice';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PowerBIService extends Baseservice {
  private apiUrl = environment.powerBIUrl;

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('power-bi', http, authentication);
}

  
  getCarrierReport(carrierCode) {
    return this.http.get(`${this.apiUrl}/api/Dashboard/withCarrierCode/${carrierCode}`);
  }

  getReportIds(){

    return this.http.get(`${this.apiUrl}/api/Dashboard`);
  }

  getWithCarrierCodeReportId(carrierCode,ReportId) {
    return this.http.get(`${this.apiUrl}/api/Dashboard/withCarrierCodeReportId/${carrierCode}/${ReportId}`);
  }

  getSanralReportId() {
    return this.http.get(`${this.apiUrl}/api/dashboard/GetReportIdsForSanral`);
  }


  getSanralReport(ReportId) {
    return this.http.get(`${this.apiUrl}/api/dashboard/withOnlyReportId/${ReportId}`);
  }

  getAdminReportId() {
    return this.http.get(`${this.apiUrl}/api/dashboard/GetReportIdsForAdmin`);
  }


  getAdminReport(ReportId) {
    return this.http.get(`${this.apiUrl}/api/dashboard/withOnlyReportIdForAdmin/${ReportId}`);
  }
}
